













import { computed, defineComponent, PropType, toRefs } from '@nuxtjs/composition-api'
import useCommentLink from '@/composables/use-comment-link'
import Store from '@/classes/Store'
import useFeatureFlag from '@/composables/use-feature-flag'
import { FeatureFlagKey } from '@/modules/growthbook/feature-flag'

export default defineComponent({
  props: {
    store: {
      type: Object as PropType<Store | null>,
      default: null,
    },
    size: {
      type: String as PropType<'xs' | 'lg'>,
      default: 'xs',
    },
    hideCount: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {
    /** FIXME: 實驗結束後刪除 */
    const { match } = useFeatureFlag()
    const ifAggregateGoogleRating = computed(() => {
      return match(FeatureFlagKey.GOOGLE_MAP_REVIEW, true)
    })

    const rating = computed(() => {
      if (!props.store) return null
      if (!ifAggregateGoogleRating.value) return props.store.rating
      return Store.aggregateGogooutAndGoogleRating(props.store.rating ?? { score: 0, count: 0 }, props.store.googleRating ?? { score: 0, count: 0 })
    })

    return {
      commentLink: useCommentLink(toRefs(props).store),
      rating,
    }
  },
})
